<template>
    <modal @close="dailyLimitCancelClick" class="edit-modal" hideFooter id="daily-limit">
        <div class="td-edit-container one-step">
            <div class="pagination">
                <div class="form-name">
                    <h3>Promotion Daily Limit</h3>

                    <div class="mt-3">
                        <p>
                            Set a daily limit to control how much is spent each day.  Once the limit is reached, the promotion will stop displaying.  The daily limit is reset everyday at 12AM CST (Midnight).
                        </p>
                    </div>

                </div>
            </div>
            <div class="edit-pages">
                <div class="mt-5">
                    <label class="td-label td-text-bold">Daily Limit ($):</label>
                    <input type="number" placeholder="" :class="[{'error': displayError['limit']}]" @input="validateDailyLimit" v-model="dailyLimit" style="width: 200px;" />  <!--:disabled="disableDailyLimit === true"-->
                    <error v-if="displayError['limit']" :error="errors['limit']"></error>

                    <div class="mt-5 mb-2">
                        <label class="td-checkbox-label td-text-bold">
                            Disable Daily Limit
                            <input name="disableDailyLimit" type="checkbox" v-model="disableDailyLimit" @click="checkDailyLimit" />
                            <span></span>
                        </label>
                    </div>
                </div>
                
                <div class="actions">
                    <div>
                        <button class="td-btn primary-outlined" @click="dailyLimitCancelClick">Cancel</button>
                    </div>
                    <div class="save-btn">
                        <button class="td-btn btn primary" @click="dailyLimitSaveClick"><span v-if="isLoading"><icon name="faSpinner" type="solid" spin></icon>&nbsp;</span>Save</button>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
    import script from './DailyLimit';
    export default script;
</script>
<style lang="less">
    @import './DailyLimit.less';
</style>